// ProtectedRoute.jsx
import { Navigate, useLocation } from "react-router-dom";

const TAP_PATHS = ["/tap-bookings", "/daily-tap", "/flights"];

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("authToken");
  const role = localStorage.getItem("userRole");
  const location = useLocation();

  if (!token) {
    return <Navigate to="/" replace />;
  }

  if (role === "tap" && !TAP_PATHS.includes(location.pathname)) {
    return <Navigate to="/tap-bookings" replace />;
  }

  return children;
};

export default ProtectedRoute;
